import ActionTypes from "../../../../constants/ActionTypes";
import { IVerificationSmsState } from "./types";

const initialState: IVerificationSmsState = {
  smsVerificationNeeded: false,
  smsVerificationSent: false,
  smsVerificationConfirmed: false
};

const smsVerificationReducer = (
  state = initialState,
  action: any,
): any => {
  switch (action.type) {
  case ActionTypes.ORDER.SEND_VERIFICATION_SMS_SUCCESS:
    return {
      ...state,
      smsVerificationSent: action.payload
    };
  case ActionTypes.ORDER.SEND_VERIFICATION_CODE_SUCCESS:
    return {
      ...state,
      smsVerificationConfirmed: action.payload
    };
  case ActionTypes.ORDER.SET_SMS_FLAGS:
    return {
      ...state,
      smsVerificationNeeded: action.payload.smsVerificationNeeded,
      smsVerificationSent: action.payload.smsVerificationSent,
      smsVerificationConfirmed: action.payload.smsVerificationConfirmed,
    };
  }
  return state;
};

export default smsVerificationReducer;
